import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RouteService } from 'src/app/services/routes/route.service';
import { FindRouteParams } from 'src/app/models/findRouteParams';
import { IonInfiniteScroll, IonRefresher } from '@ionic/angular';
import { Route } from 'src/app/models/route';
import { AlertService } from 'src/app/services/alert/alert.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { first } from 'rxjs/operators';
import { Storage } from '@ionic/storage';
import moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PACKAGE_SIZE, ROUTE_TYPE, PACKAGE_TYPE } from 'src/app/constants';
import { AuthGuard } from 'src/app/services/auth/guard.service';


const INPUT_FORMAT = 'DD/MM/YYYY';
const MAX_PACKAGE_WEIGHT = 75 * 10 * 10 * 10;
const MAX_PACKAGE_NUMBERS = 50 * 10 * 10 * 10;

@Component({
  selector: 'app-find-carry',
  templateUrl: './find-carry.page.html',
  styleUrls: ['./find-carry.page.scss'],
})
export class FindCarryPage implements OnInit {
  @ViewChild(IonInfiniteScroll, { static: false }) infiniteScroll: IonInfiniteScroll;
  @ViewChild(IonRefresher, { static: false }) refresher: IonRefresher;

  routes: Route[] = [];
  findParams: FindRouteParams;
  payNowValue: number | null = null;
  payNowVisible: boolean = true;
  payNowLoad: boolean = false;

  form: FormGroup;
    packageSizes = Object.keys(PACKAGE_SIZE);
    packageTypes = Object.keys(PACKAGE_TYPE);
    minDate = new Date();
    date = moment();
    verboseFromProvince: string;
  verboseFromRegion: string;
  verboseToProvince: string;
  verboseToRegion: string;
  sendObjects = [];
  payNowSession: string;

  constructor(
    private alert: AlertService,
    public spinner: SpinnerService,
    private activatedRoute: ActivatedRoute,
    private auth: AuthService,
    private profileService: ProfileService,
    private routeService: RouteService,
    private storage: Storage,
    private router: Router,
    protected fb: FormBuilder) {
      this.form = this.fb.group({
            type: [ROUTE_TYPE.send, Validators.required],
            from: ['', [Validators.required]],
            to: ['', Validators.required],
            date: ['', Validators.required],
            arrivalDate: ['', Validators.required],
            packageSize: [''],
            packageType: [],
            packagesNumber: [, [Validators.min(0), Validators.max(MAX_PACKAGE_NUMBERS)]],
            packageWeight: [, [Validators.required, Validators.min(1), Validators.max(MAX_PACKAGE_WEIGHT)]],
            packageFragile: [false],
            packageFlammable: [false],
            gpsEnabled: [false],
            professionalCarrier: [false],
            fromCountryCode: [''],
            toCountryCode: [''],
          });
  }

  initForm(value: Route | FindRouteParams) {
    const { maximumPrice, packageType } = value;
    
    if (!packageType) {
      value.packageType = PACKAGE_TYPE.other;
    }

    delete value.maximumPrice;
    
    this.form.patchValue(value);
  }
  
  async ngOnInit() {
    this.activatedRoute.queryParams
      .pipe(first())
      .subscribe((params: FindRouteParams) => {
        this.findParams = {
          ...params,
          offset: 0
        };
        this.fetch();

         const value = { ...params };
                this.verboseFromProvince = value.verboseFromProvince ? value.verboseFromProvince : '';
                this.verboseFromRegion = value.verboseFromRegion ? value.verboseFromRegion : '';
                this.verboseToProvince = value.verboseToProvince ? value.verboseToProvince : '';
                this.verboseToRegion = value.verboseToRegion ? value.verboseToRegion : '';
        
                delete value.type;
                this.initForm(value);
                this.selectedDate(moment(value.date));
                if (value.arrivalDate) {
                  this.selectedArrivalDate(moment(value.arrivalDate));
                }

                this.payNowSession = params.payNowSession;
                console.log('payNowSession:', this.payNowSession);
                console.log('params:', this.findParams);

        this.loadPayNow();
      });
  }

  async fetch() {
    if (this.invalidParams()) {
      await this.alert.redirect(['/tabs/send'], '', 'FIND_ROUTE_INVALID_PARAMS');
      return;
    }

    try {
      await this.spinner.show();

      let token;
      try {
        token = await this.profileService.getProfile() && await this.auth.getToken();
      } catch (err) {
      }

      const { body, headers } = await this.routeService.search(token, this.findParams);

      // INFINITE SCROLL DISABLED
      // this.routes = this.routes.concat(body);
      // this.findParams.offset += body.length;
      // const count = parseInt(headers.get('x-total-count'), 10);
      // this.infiniteScroll.complete();
      // this.infiniteScroll.disabled = this.routes.length >= count;
      this.routes = body;
      this.infiniteScroll.disabled = true;

      if (!token) {
        await this.storage.set('lastUserSearch', this.router.url);
      }

      await this.spinner.dismiss();
    } catch (err) {
      this.infiniteScroll.disabled = true;
      this.infiniteScroll.complete();
      this.spinner.dismissWithAlertError(err);
    }

  }

  onRefresh() {
    this.routes = [];
    this.findParams.offset = 0;
    this.fetch();

    this.refresher.complete();
  }

  invalidParams() {
    const { type, from, to, date } = this.findParams;
    return !type || !from || !to || !date;
  }

  selectedDate(date: moment.Moment) {
      this.date = date;
      this.form.get(`date`).setValue(date.format(INPUT_FORMAT));
      const arrivalDateValue = this.form.get(`arrivalDate`).value;
  
      // If arrival is before trip date, set it null
      if (arrivalDateValue) {
        if (moment(arrivalDateValue, INPUT_FORMAT).isBefore(date, 'day')) {
          this.form.get(`arrivalDate`).setValue(null);
        }
      }
    }

    selectedArrivalDate(date: moment.Moment) {
        this.form.get(`arrivalDate`).setValue(date.format(INPUT_FORMAT));
      }

      getRouteElements() {
          const route = this.form.value;
          const { packageSize, date, arrivalDate, packageType } = route;
      
          route.date = moment(date, INPUT_FORMAT);
      
          if (arrivalDate) {
            route.arrivalDate = moment(arrivalDate, INPUT_FORMAT);
          } else {
            delete route.arrivalDate;
          }
      
          if (typeof packageSize !== 'string') {
            delete route.packageSize;
          }
          if (typeof packageType !== 'string') {
            delete route.packageType;
          }

          if (this.verboseFromProvince) {
        route.verboseFromProvince = this.verboseFromProvince;
      }
      if (this.verboseFromRegion) {
        route.verboseFromRegion = this.verboseFromRegion;
      }
      if (this.verboseToProvince) {
        route.verboseToProvince = this.verboseToProvince;
      }
      if (this.verboseToRegion) {
        route.verboseToRegion = this.verboseToRegion;
      }

      route.routeObjects = this.sendObjects.map(obj => ({
        name: obj.name,
        width: obj.width,
        height: obj.height,
        length: obj.length,
        weight: obj.weight
      }));

          return route;
        }

  async loadPayNow() {
    this.payNowVisible = false;
      return;

    // const savedObjects = await this.storage.get('send_objects');

    // if (!savedObjects || !Array.isArray(savedObjects) || savedObjects.length === 0) {
    //   this.payNowVisible = false;
    //   return;
    // }

    // this.sendObjects = savedObjects;

    // const route = this.getRouteElements();

    // this.payNowLoad = true;
    // try {
    //   delete route.maximumPrice;
    //   const payNow = await this.routeService.getPayNow(route);
    //   this.payNowValue = payNow.payNowPrice;
    //   this.payNowLoad = false;
    //   this.payNowVisible = this.payNowValue !== null && this.payNowValue > 0;
    // } catch (err) {
    //   this.payNowLoad = false;
    //   this.payNowVisible = false;
    //   console.error('Errore nel calcolare Pay Now:', err);
    // }
  }

  async onPayNowClick() {
    if (this.payNowLoad) {
      return;
    }

    const authGuard = new AuthGuard(this.auth, this.alert, this.profileService, this.storage, this.router);
    const canProceed = await authGuard.canActivate(null, { url: this.router.url } as any);

    if (!canProceed) {
      return;
    }

    this.payNowLoad = true;
    try {
      const route = this.getRouteElements();
      route.payNowSession = this.payNowSession;
      const token = await this.auth.getToken();
      const travel = await this.routeService.payNow(token, route);
      const id = travel.id;
      this.router.navigate(['/payment-summary', id]);
    } catch (err) {
      this.spinner.dismissWithAlertError(err);
    }
    this.payNowLoad = false;
  }

  private async loadSendObjectsFromStorage(): Promise<void> {
    try {
      const savedObjects = await this.storage.get('send_objects');
      console.log('sendObjects caricati dallo storage:', savedObjects);
      if (savedObjects && Array.isArray(savedObjects) && savedObjects.length > 0) {
        this.sendObjects = savedObjects;
      } else {
        this.sendObjects = [];
      }
    } catch (error) {
      console.error('Errore nel caricare sendObjects dallo storage:', error);
    }
  }
}
